/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { Icon } from "@material-ui/core";
import adminMenu from "./roles-menues/admin.json";
import employeeMenu from "./roles-menues/employee.json";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();

  const { isEmployee } = useSelector(({ auth }) => ({
    isEmployee: auth.user?.roles?.includes(2) || auth.user?.roles?.includes(6),
  }));

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
      "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const menu = isEmployee ? employeeMenu : adminMenu;

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {menu.map((item, index) => (
          <React.Fragment key={index}>
            {item.section && (
              <li className="menu-section ">
                <h4 className="menu-text">{item.title}</h4>
                <i className="menu-icon flaticon-more-v2"></i>
              </li>
            )}
            <li
              className={`menu-item ${getMenuItemActive(
                item.url,
                item.subMenu
              )}`}
              aria-haspopup="true"
              {...(item.subMenu && { "data-menu-toggle": "hover" })}
            >
              <NavLink className={item.subMenu ? "menu-link menu-toggle" : "menu-link"} to={item.url}>
                <span className="svg-icon menu-icon">
                  {item.iconUrl && <SVG src={toAbsoluteUrl(item.iconUrl)} />}
                  {item.icon && <Icon className={item.icon} />}
                </span>
                <span className="menu-text">{item.title}</span>
                {item.subMenu && <i className="menu-arrow" />}
              </NavLink>
              {item.subMenu && (
                <div className="menu-submenu">
                  <i className="menu-arrow" />
                  <ul className="menu-subnav">
                    <li
                      className="menu-item  menu-item-parent"
                      aria-haspopup="true"
                    >
                      <span className="menu-link">
                        <span className="menu-text">{item.title}</span>
                      </span>
                    </li>
                    {item.subMenu.map((subItem, subIndex) => (
                      <li
                        key={subIndex}
                        className={`menu-item ${getMenuItemActive(
                          subItem.url
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink className="menu-link" to={subItem.url}>
                          <span className="svg-icon menu-icon">
                            <Icon className={subItem.icon} />
                          </span>
                          <span className="menu-text">{subItem.title}</span>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li >
          </React.Fragment>
        ))
        }
      </ul>
      {/* end::Menu Nav */}
    </>
  );
}
